import { Link } from "react-router-dom";
import { XCircle, ArrowUpRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div
      data-testid="payment-cancel-page"
      className="relative bg-white min-h-[70vh] border-b-2 border-[#1A1A1A]"
    >
      <div className="absolute inset-0 bg-grid opacity-50 pointer-events-none" />
      <div className="relative mx-auto max-w-3xl px-5 md:px-10 lg:px-12 py-24 md:py-32">
        <div className="rounded-3xl border-2 border-[#1A1A1A] bg-white p-8 md:p-12 nb-shadow-lg">
          <div className="inline-flex items-center justify-center h-16 w-16 rounded-2xl bg-[#FFD700] border-2 border-[#1A1A1A] nb-shadow-sm">
            <XCircle size={30} strokeWidth={2.5} />
          </div>
          <h1 className="mt-6 font-display font-black text-4xl md:text-5xl leading-tight tracking-tighter">
            Checkout cancelled.
          </h1>
          <p className="mt-4 text-[#4A4A4A] font-medium text-lg">
            No charge was made. Whenever you’re ready, pick your plan again — or
            book a discovery call so we can help you choose.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/pricing"
              data-testid="payment-cancel-retry-btn"
              className="inline-flex items-center gap-2 bg-[#0055FF] text-white border-2 border-[#1A1A1A] rounded-full px-6 py-3 font-bold uppercase text-sm tracking-wide nb-shadow-sm nb-press"
            >
              Back to pricing <ArrowUpRight size={16} strokeWidth={2.5} />
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center gap-2 bg-[#FFD700] text-[#1A1A1A] border-2 border-[#1A1A1A] rounded-full px-6 py-3 font-bold uppercase text-sm tracking-wide nb-shadow-sm nb-press"
            >
              Talk to us
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
